import React, { ReactElement } from 'react';
import { useTheme } from '../../../../providers/theme';
import { Switch } from '../../../Switch';
import './index.module.css';

export interface ThemeSwitchProps {
  labelLeft?: string;
  labelRight?: string;
}

export const ThemeSwitch = ({
  labelLeft = '',
  labelRight = '',
}: ThemeSwitchProps): ReactElement => {
  const [theme, setTheme] = useTheme();
  const handleThemeSwitch = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
  };

  return (
    <div className="header-item">
      <Switch
        checked={theme === 'dark'}
        labelLeft={labelLeft}
        labelRight={labelRight}
        onChange={() => handleThemeSwitch()}
      />
    </div>
  );
};
